<template>
  <div>
    <ion-list lines="none">
      <ion-item button @click="share" disabled>
        <ion-icon color="primary" slot="start" name="share"></ion-icon>
        <ion-label>Share</ion-label>
      </ion-item>
    </ion-list>
  </div>
</template>
<script>
export default {
  methods: {
    share() {
      this.$ionic.dismissPopover();
    }
  }
};
</script>
